import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_split_t_039LayoutModel extends FlyerLayoutAbstract {
  flourishes = []

  textLayouts = {
    event_name_1: {
      top: 40,
      left: 17,
      size: 45,
      width: 286,
      height: 132,
      align: 'left'
    },
    location_1: {
      top: 440,
      right: 17,
      size: 17,
      width: 286,
      height: 17,
      align: 'right'
    },
    location_2: {
      top: 457,
      right: 17,
      size: 16,
      width: 250,
      height: 80,
      align: 'right'
    }
  }

  dateLayouts = {
    date_1: {
      top: 402,
      right: 17,
      daySize: 17,
      lineHeight: 17,
      height: 17,
      width: 286,
      align: 'right'
    },
    date_2: {
      top: 418,
      right: 17,
      daySize: 17,
      lineHeight: 17,
      height: 17,
      width: 286,
      align: 'right'
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText2() {
    return this.hobnobFormattedAddressWithCity() || ''
  }

  dayShortSuffixForDate(date) {
    const d = moment(date).date()
    if (d > 3 && d < 21) return 'TH'
    switch (d % 10) {
      case 1: return 'ST'
      case 2: return 'ND'
      case 3: return 'RD'
      default: return 'TH'
    }
  }

  stripZerosForHour(timeStr) {
    return timeStr.replace(/^0+/, '')
  }

  getEventDateLabel({ eventStartDate, eventEndDate, eventTimeZone }) {
    if (!eventStartDate) return null

    const tz = eventTimeZone || 'UTC'
    const start = moment.tz(eventStartDate, tz)
    const end = eventEndDate ? moment.tz(eventEndDate, tz) : null
    const getDayWithSuffix = (dateObj, rawDate) =>
      dateObj.format('ddd, MMM ') + dateObj.date() + this.dayShortSuffixForDate(rawDate)

    if (!end) {
      const dayStr = getDayWithSuffix(start, eventStartDate)
      const timeStr = start.format('h:mma').toUpperCase()
      return `${dayStr} - ${timeStr}`
    }

    if (start.isSame(end, 'day')) {
      const dayStr = getDayWithSuffix(start, eventStartDate)
      const startTime = start.format('h:mma').toUpperCase()
      const endTime = end.format('h:mma').toUpperCase()
      return `${dayStr}\n${startTime} till ${endTime}`
    }

    const startDayStr = getDayWithSuffix(start, eventStartDate)
    const startTime = start.format('h:mma').toUpperCase()
    const endDayStr = getDayWithSuffix(end, eventEndDate)
    const endTime = end.format('h:mma').toUpperCase()
    return `${startDayStr} ${startTime}\ntill ${endDayStr} ${endTime}`
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'

    const { daySize, left, right, top, align, width, height } = this.dateLayouts.date_1

    const { daySize: daySize2, left: left2, right: right2, top: top2, align: align2, width: width2, height: height2 } = this.dateLayouts.date_2

    const safeDate1Color = this.dateProps.date1Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate1Font = this.dateProps.date1Props?.font?.replace(/\s+/g, '-') || 'Arial'

    const safeDate2Color = this.dateProps.date2Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate2Font = this.dateProps.date2Props?.font?.replace(/\s+/g, '-') || 'Arial'

    let dates = []

    if (!startDate) return { type: 'date', dates }
    const text = this.getEventDateLabel({ eventStartDate: startDate, eventEndDate: endDate, eventTimeZone: timeZone })

    const dateTexts = text.split('\n')

    if (dateTexts.length > 1) {
      dateTexts.forEach((text) => {
        if (text.includes('till')) {
          const [leftText, rightText] = text.split('till')
          const rightTextTrimmed = rightText.trim() || ''
          const leftTextTrimmed = leftText.trim() || ''
          const tillText = 'till'

          if (rightTextTrimmed) {
            dates.push({
              text: tillText,
              width: 50,
              height: height2,
              left: leftTextTrimmed ? 207 : 85,
              top: top2 + 4,
              color: safeDate2Color,
              font: safeDate2Font,
              size: 12
            })
            dates.push({
              text: rightText.trim(),
              align: align2,
              width: width2,
              height: height2,
              left: left2,
              right: right2,
              top: top2,
              color: safeDate2Color,
              font: safeDate2Font,
              size: daySize2
            })
          }
          if (leftTextTrimmed) {
            dates.push({
              text: leftText.trim(),
              align,
              width,
              height,
              right: right2 + 100,
              top: top2,
              color: safeDate2Color,
              font: safeDate2Font,
              size: daySize2
            })
          }
        } else {
          dates.push({
            text,
            align,
            width,
            height,
            left,
            right,
            top: top,
            color: safeDate1Color,
            font: safeDate1Font,
            size: daySize
          })
        }
      })
    } else {
      dates.push({
        text,
        align,
        width,
        height,
        left,
        right,
        top: top2,
        color: safeDate1Color,
        font: safeDate1Font,
        size: daySize
      })
    }

    return { type: 'date', dates }
  }
}
